import { render, staticRenderFns } from "./BarChart5.vue?vue&type=template&id=42fd1dd6&scoped=true"
import script from "./BarChart5.vue?vue&type=script&lang=js"
export * from "./BarChart5.vue?vue&type=script&lang=js"
import style0 from "./BarChart5.vue?vue&type=style&index=0&id=42fd1dd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fd1dd6",
  null
  
)

export default component.exports